import { Nav, NavItem, NavLink } from 'reactstrap';

import Icon from 'components/Icon';

export interface TabItem {
  id: string;
  label: string;
  icon?: string;
  iconSize?: string;
}

interface CustomTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const SegmentTabs = ({ tabs, activeTab, onTabChange }: CustomTabsProps): JSX.Element => {
  return (
    <Nav
      tabs
      style={{
        backgroundColor: '#E5EBF4',
        borderRadius: '4px',
        paddingTop: 0,
      }}
    >
      {tabs.map(tab => (
        <NavItem
          key={tab.id}
          style={{
            minHeight: '28px',
            borderRadius: '6px',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '3px',
            paddingBottom: 0,
            ...(tab.id === activeTab ? { backgroundColor: 'white' } : {}),
          }}
          onClick={() => onTabChange(tab.id)}
        >
          <NavLink
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#3A5371',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500',
            }}
            className={activeTab === tab.id ? 'active' : ''}
          >
            {tab.icon && (
              <Icon
                style={{
                  marginRight: '8px',
                  fontSize: tab.iconSize || '14px',
                }}
                iconName={tab.icon}
              />
            )}
            {tab.label}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default SegmentTabs;
